import { IPersonDetailState } from './state.store'
import  { GetterTree } from 'vuex';

const getters: GetterTree<IPersonDetailState, {}> = <GetterTree<IPersonDetailState, {}>>{
    service: (state: IPersonDetailState) => state.service,
    personModel: (state: IPersonDetailState) => state.personModel,
    
}

export default getters;